
export class League {
  id: number | null = null ;
  guid: string | null = null ;
  name: string | null = null ;
  country: any = [];
}
